import {
  Component,
  EventEmitter,
  Input,
  Output,
  TemplateRef,
} from '@angular/core';
import { RR_TABLE_ACTION_TYPE } from '../../../common/enum/table/table-action-type.enum';
import { RRIBaseTableActionSettings } from '../../../common/interfaces/table/base-table-action-settings.interface';
import { RRITableActionOutput } from '../../../common/interfaces/table/table-action-output.interface';
import { RRITableAddActionSettings } from '../../../common/interfaces/table/table-add-action-settings.interface';
import { RRTableFieldSettingsModel } from '../../../common/models/table/table-fields.model';

@Component({
  selector: 'rr-table-buttons',
  templateUrl: './table-buttons.component.html',
  styleUrls: ['./table-buttons.component.scss'],
})
export class TableButtonsComponent<T> {
  @Input() isLoading: boolean;
  @Input() recourdCount: number;
  @Input() addAction: RRITableAddActionSettings<T>;
  @Input() excelAction: RRIBaseTableActionSettings;
  @Input() visibleColumns: (keyof T)[];
  @Input() fieldsToShow: RRTableFieldSettingsModel<T>[];
  @Input() addButtonLeft: TemplateRef<any>;
  @Input() addButtonRight: TemplateRef<any>;

  @Output() actionClicked: EventEmitter<RRITableActionOutput<T>> =
    new EventEmitter();
  @Output() changeVisibleColumns: EventEmitter<(keyof T)[]> =
    new EventEmitter();

  constructor() {}

  public onAddNew(): void {
    this.actionClicked.emit({
      action: { type: RR_TABLE_ACTION_TYPE.ADD, settings: this.addAction },
      row: null,
    });
  }

  public onExportExcel(): void {
    this.actionClicked.emit({
      action: { type: RR_TABLE_ACTION_TYPE.EXCEL, settings: this.excelAction },
      row: null,
    });
  }

  public shouldShowAddButton(): boolean {
    return this.addAction && !this.addAction.hide;
  }

  public shouldShowExcelButton(): boolean {
    return this.excelAction && !this.excelAction.hide && this.recourdCount > 0;
  }

  public changeStatus(fieldName: keyof T): void {
    let visibleColumns = this.visibleColumns;
    if (!visibleColumns) {
      visibleColumns = [];
    }

    if (visibleColumns.includes(fieldName)) {
      visibleColumns = visibleColumns.filter((col) => col !== fieldName);
    } else {
      visibleColumns.push(fieldName);
    }

    this.changeVisibleColumns.emit(visibleColumns);
  }

  public checkColDisplay(fieldName: keyof T): boolean {
    return this.visibleColumns && this.visibleColumns.includes(fieldName);
  }
}
